import React, { useEffect, useState } from 'react';
import classes from "./HomePage.module.css";
import { FaStarOfLife, FaChevronDown } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import {
    Autoplay,
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Keyboard,
    EffectCoverflow,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import {
    FaArrowRight, FaBars,
    FaXmark,
} from "react-icons/fa6";
import { fetchGamesApi } from '../http/http';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {

    const [gamesOpen, setGamesOpen] = useState(false);
    const [desktopGamesOpen, setDesktopGamesOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [mobileGamesOpen, setMobileGamesOpen] = useState(false);

    const navigate=useNavigate();

    const [categories, setCategories] = useState([]);

    const [games, setGames] = useState([]);

    const [topGames, setTopGames] = useState([]);
    const [carousel, setCarousel] = useState([]);

    const fetchGames = async () => {
        try {
            const response = await fetchGamesApi();
            setCategories(response?.data?.data?.categories || []);
            let allGames = response?.data?.data?.games || [];

            const randomFiveGames = [...allGames]
                .sort(() => 0.5 - Math.random())
                .slice(0, 20);

            setTopGames(randomFiveGames.slice(0, 5) || []);
            setCarousel(randomFiveGames || []);

            setGames(() => {
                return response?.data?.data?.categories?.map(category => {
                    return {
                        ...category,
                        games: allGames.filter(game => game.category_id === category.id)
                    }
                });
            })
        } catch (error) {
            console.log(error, "error in fetching games");
        }
    }

    useEffect(() => {
        fetchGames();
    }, []);

    const handleNavigate = (url) => {
        window.location.href = url;
    }

    console.log(games, 'games---');

    return (
        <>
            {/* <header className={classes.header}>
                <nav className={classes.nav}>
                    <div className={classes.nav_items}>
                        <div className={classes.logo_container}>
                            <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                            <p className={classes.logo_text}>Game<span>
                                Plex
                            </span>
                            </p>
                        </div>

                        <div className={classes.nav_items_data}>
                            <button type="button" className={classes.nav_items_data_item}>
                                Home
                            </button>

                            <div
                                className={classes.dropdown_wrapper}
                                onMouseEnter={() => setGamesOpen(true)}
                                onMouseLeave={() => setGamesOpen(false)}
                            >
                                <button type="button" className={classes.nav_items_data_item}
                                >
                                    Games
                                    <FaChevronDown className={classes.chevron_icon} />
                                </button>

                                {gamesOpen && (
                                    <div className={classes.dropdown_menu}>
                                        <p className={classes.dropdown_item}>Action</p>
                                        <p className={classes.dropdown_item}>Adventure</p>
                                        <p className={classes.dropdown_item}>Casual</p>
                                        <p className={classes.dropdown_item}>Puzzle</p>
                                    </div>
                                )}

                            </div>

                            <button type="button" className={classes.nav_items_data_item}>
                                Terms & Conditions
                            </button>

                            <button type="button" className={classes.subscribe_button}>
                                <span className={classes.star_icon_container}>
                                    <FaStarOfLife className={classes.star_icon} />
                                </span>
                                Subscribe
                            </button>
                        </div>

                        <button type="button" className={classes.avatar_icon_container}>
                            <img src="/assets/images/user.png" alt="avatar" className={classes.avatar} />
                            Harvey Spectar
                            <FaChevronDown className={classes.chevron_icon} />
                        </button>
                    </div>
                </nav>
            </header> */}

            {/* ================= HEADER ================= */}
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <div className={classes.nav_items}>

                        {/* Logo */}
                        <div className={classes.logo_container}>
                            <img
                                src="/assets/images/logo.png"
                                alt="logo"
                                className={classes.logo}
                            />
                            <p className={classes.logo_text}>
                                Game<span>Plex</span>
                            </p>
                        </div>

                        {/* Desktop Menu */}
                        <div className={classes.nav_items_data}>
                            <button className={classes.nav_items_data_item}>Home</button>

                            <div
                                className={classes.dropdown_wrapper}
                                onMouseEnter={() => setDesktopGamesOpen(true)}
                                onMouseLeave={() => setDesktopGamesOpen(false)}
                            >
                                <button className={classes.nav_items_data_item}>
                                    Games
                                    <FaChevronDown
                                        className={`${classes.chevron_icon} ${desktopGamesOpen ? classes.rotate : ""
                                            }`}
                                    />
                                </button>

                                {desktopGamesOpen && (
                                    <div className={classes.dropdown_menu}>
                                        {
                                            categories.map((category) => (
                                                <p key={category.id} className={classes.dropdown_item}
                                                onClick={()=>navigate(`/games/${category.id}/${category.category_name}`)}
                                                >{category.category_name}</p>
                                            ))
                                        }
                                    </div>
                                )}
                            </div>

                            {/* <button className={classes.nav_items_data_item}>
                                Terms & Conditions
                            </button> */}

                            <button className={classes.subscribe_button}>
                                <span className={classes.star_icon_container}>
                                    <FaStarOfLife />
                                </span>
                                Subscribe
                            </button>
                        </div>

                        {/* Desktop Avatar */}
                        <button className={classes.avatar_icon_container}>
                            <img
                                src="/assets/images/user.png"
                                alt="avatar"
                                className={classes.avatar}
                            />
                            Harvey Spectar
                            <FaChevronDown className={classes.chevron_icon} />
                        </button>

                        {/* Hamburger */}
                        <button
                            className={classes.hamburger}
                            onClick={() => setMobileMenuOpen(true)}
                            aria-label="Open menu"
                        >
                            <FaBars />
                        </button>
                    </div>
                </nav>
            </header>

            {/* ================= OVERLAY ================= */}
            {mobileMenuOpen && (
                <div
                    className={classes.overlay}
                    onClick={() => {
                        setMobileMenuOpen(false);
                        setMobileGamesOpen(false);
                    }}
                />
            )}

            {/* ================= MOBILE DRAWER ================= */}
            <div
                className={`${classes.mobile_drawer} ${mobileMenuOpen ? classes.open : ""
                    }`}
            >
                <button
                    className={classes.close_btn}
                    onClick={() => {
                        setMobileMenuOpen(false);
                        setMobileGamesOpen(false);
                    }}
                    aria-label="Close menu"
                >
                    <FaXmark />
                </button>

                <button className={classes.drawer_item}>Home</button>

                {/* Drawer Dropdown */}
                <div className={classes.drawer_dropdown}>
                    <button
                        className={classes.drawer_item}
                        onClick={() => setMobileGamesOpen(!mobileGamesOpen)}
                    >
                        Games
                        <FaChevronDown
                            className={`${classes.chevron_icon} ${mobileGamesOpen ? classes.rotate : ""
                                }`}
                        />
                    </button>

                    <div
                        className={`${classes.drawer_submenu} ${mobileGamesOpen ? classes.open : ""
                            }`}
                    >
                        {categories.map((category) => (
                            <p key={category.id} className={classes.drawer_subitem}
                            onClick={()=>   navigate(`/games/${category.id}/${category.category_name}`)}
                            >{category.category_name}</p>
                        ))}
                    </div>
                </div>

                {/* <button className={classes.drawer_item}>Terms & Conditions</button> */}

                <button className={classes.drawer_subscribe}>Subscribe</button>
            </div>

            <section className={classes.hero_section}>
                <div className={classes.gradient_bg_1}></div>
                <div className={classes.gradient_bg_2}></div>
                <video autoPlay muted loop controls={false} className={classes.video_animation} >
                    <source src="/assets/video/hero_video.mp4" type="video/mp4" />
                </video>

                <div className={classes.hero_section_container}>
                    <div className={classes.hero_section_one}>
                        <div className={classes.title_section_one}>
                            <span className={classes.title_small}>Play</span>
                            <span className={classes.title_small}>Earn</span>
                            <span className={classes.title_small}>Enjoy</span>
                        </div>

                        <div className={classes.hero_section_two}>
                            <h1 className={classes.title_big}>
                                Ultimate
                            </h1>
                            <h1 className={classes.title_highlight}>
                                Gamer's
                            </h1>
                            <h1 className={classes.title_big}>
                                Haven
                            </h1>
                            <button type="button" className={classes.hero_play_button}>
                                Play Now
                            </button>
                        </div>

                    </div>

                    <div className={classes.hero_section_two}>
                        <img src="/assets/images/gradient.png" alt="gradient" className={classes.hero_section_two_image} />
                        <img src="/assets/images/player.png" alt="player" className={classes.player_image} />
                    </div>

                    <div className={classes.hero_section_three}>
                        <div className={classes.hero_section_three_container}>
                            <h3 className={classes.hero_section_three_heading}>Top Games</h3>

                            {topGames.map((game, idx) => (
                                <div className={classes.hero_section_three_game_container} key={idx}
                                    onClick={() => handleNavigate(game?.game_url)}
                                >
                                    <div className={classes.hero_section_three_game_image_container}>
                                        <img src={game?.game_banner} alt="game" className={classes.hero_section_three_game_image} />
                                    </div>
                                    <div className={classes.hero_section_three_content_container}>
                                        <p className={classes.hero_section_three_game_name}>{game?.game_name}</p>
                                        <p className={classes.hero_section_three_game_desc}>{game?.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* <div className={classes.cards_container}>
                            <div className={classes.cards}>
                                <img
                                    src={"/assets/images/game1.png"}
                                    className={classes.card}
                                    style={{ left: `10px` }}
                                    alt="avatar"
                                />
                                <img
                                    src={"/assets/images/game2.png"}
                                    className={classes.card}
                                    style={{ left: `20px` }}
                                    alt="avatar"
                                />
                                <img
                                    src={"/assets/images/game3.png"}
                                    className={classes.card}
                                    style={{ left: `30px` }}
                                    alt="avatar"
                                />
                                <div className={classes.badge} style={{ left: `40px` }}>
                                    99+
                                </div>
                            </div>
                        </div>
                        <div className={classes.label}>
                            <span className={classes.dot} /> Games
                        </div> */}
                    </div>
                </div>
            </section>

            <section className={classes.carousel_section}>
                <div className={classes.carousel_sub_section}>
                    <Swiper
                        modules={[
                            Autoplay,
                            EffectCoverflow,
                            Navigation
                        ]}
                        loop
                        effect={"coverflow"}
                        coverflowEffect={{
                            slideShadows: false,
                            rotate: 40
                        }
                        }
                        spaceBetween={0}
                        // slidesPerView={3}
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                                spaceBetween: 16,
                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 0,
                            },
                        }}
                        // slidesPerView={'auto'}
                        autoplay={{
                            delay: 1000,
                            disableOnInteraction: false,
                        }}
                        navigation={{
                            prevEl: ".custom-swiper-prev",
                            nextEl: ".custom-swiper-next",
                        }}
                        onSwiper={(swiper) => null}
                        onSlideChange={() => null}
                    >
                        {carousel.map((game, idx) => (
                            <SwiperSlide>
                                <div className={classes.carousel_item}
                                onClick={()=>handleNavigate(game?.game_url)}
                                >
                                    <div className={classes.carousel_item_image}>
                                        <img src={game?.game_banner} alt={game?.game_name} className={classes.carousel_image} />
                                        <button className={classes.carousel_item_button}>
                                            Play Now
                                        </button>
                                    </div>
                                    <div className={classes.carousel_item_desc}>
                                        <p className={classes.carousel_item_text}>{game?.game_name}</p>
                                        <div className={classes.carousel_item_stars}>
                                            {Array.from({ length: Math.random() < 0.5 ? 4 : 5 }).map((_, index) => (
                                                <FaStar key={index} className={classes.carousel_star_icon} />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <div className={classes.carousel_navigation}>
                        <button className={`custom-swiper-prev ${classes.nav_button}`}>
                            <FaChevronLeft />
                        </button>

                        <button className={`custom-swiper-next ${classes.nav_button}`}>
                            <FaChevronRight />
                        </button>
                    </div>
                </div>
            </section>

            <section className={classes.games_carousel}>
                {games?.slice(0, 1)?.map((game, idx) => {
                    return (
                        <>
                            <div className={classes.games_carousel_header}>
                                <h1 className={classes.games_carousel_title}>{game?.category_name} Games</h1>

                                <button className={classes.game_carousel_header_button}>
                                    <FaArrowRight className={classes.game_carousel_link_arrow} />
                                </button>
                            </div>

                            <div className={classes.games_carousel_sub_section}>
                                <Swiper
                                    modules={[
                                        Autoplay,
                                        Navigation,
                                        Keyboard
                                    ]}
                                    slidesPerGroupSkip={1}
                                    grabCursor={true}
                                    keyboard={{
                                        enabled: true,
                                    }}
                                    loop
                                    spaceBetween={8}
                                    // slidesPerView={3}
                                    slidesPerView={'auto'}
                                    autoplay={{
                                        delay: 1000,
                                        disableOnInteraction: false,
                                    }}
                                    // navigation={{
                                    //     prevEl: ".custom-swiper-prev",
                                    //     nextEl: ".custom-swiper-next",
                                    // }}
                                    onSwiper={(swiper) => null}
                                    onSlideChange={() => null}
                                >
                                    {
                                        game?.games?.map((g, index) => (
                                            <SwiperSlide className={classes.game_carousel_container_slide}
                                            key={index}
                                             onClick={()=>handleNavigate(g?.game_url)}
                                            >
                                                <div className={classes.game_carousel_container}>
                                                    <div className={classes.game_carousel_header}>
                                                        <div className={classes.game_carousel_header_item1}>
                                                            <div className={classes.game_carousel_image}>
                                                                <img src={g?.game_banner} alt={g?.game_name} className={classes.game_carousel_img} />
                                                            </div>
                                                            <div className={classes.game_carousel_title_container}>
                                                                <p className={classes.game_carousel_title}>
                                                                    {g?.game_name}
                                                                </p>
                                                                {/* <p className={classes.game_carousel_category}>
                                                                    {game?.category_name}
                                                                </p> */}
                                                            </div>
                                                        </div>

                                                        <div className={classes.game_carousel_header_item2}>
                                                            <button className={classes.game_carousel_header_button}>
                                                                <FaArrowRight className={classes.game_carousel_link_arrow} />
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <p className={classes.game_carousel_game_desc}>
                                                        {g?.description}
                                                    </p>
                                                    <button type="button" className={classes.hero_play_button}>
                                                        Play Now
                                                    </button>
                                                </div>
                                            </SwiperSlide>
                                        ))
                                    }
                                </Swiper>
                            </div>
                        </>


                    )
                })}
            </section >

            <section className={classes.games_category_section}>
                <div className={classes.games_grid_container}>
                    {categories.map((item, index) => (
                        <div
                            key={index}
                            className={`${classes.game_grid_item} ${index === 0 ? classes.featured : ""
                                }`}
                        >
                            <img
                                src={item.category_img}
                                alt={item.category_name}
                                className={classes.game_grid_item_image}
                            />

                            <div className={classes.game_grid_overlay}>
                                <span>{item.category_name}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section className={classes.games_carousel}>

                {games?.slice(1, 2)?.map((game, idx) => {
                    return (
                        <>
                            <div className={classes.games_carousel_header}>
                                <h1 className={classes.games_carousel_title}>{game?.category_name} Games</h1>

                                <button className={classes.game_carousel_header_button}>
                                    <FaArrowRight className={classes.game_carousel_link_arrow} />
                                </button>
                            </div>

                            <div className={classes.games_carousel_sub_section}>
                                <Swiper
                                    modules={[
                                        Autoplay,
                                        Navigation,
                                        Keyboard
                                    ]}
                                    slidesPerGroupSkip={1}
                                    grabCursor={true}
                                    keyboard={{
                                        enabled: true,
                                    }}
                                    loop
                                    spaceBetween={8}
                                    // slidesPerView={3}
                                    slidesPerView={'auto'}
                                    autoplay={{
                                        delay: 1000,
                                        disableOnInteraction: false,
                                    }}
                                    // navigation={{
                                    //     prevEl: ".custom-swiper-prev",
                                    //     nextEl: ".custom-swiper-next",
                                    // }}
                                    onSwiper={(swiper) => null}
                                    onSlideChange={() => null}
                                >
                                    {
                                        game?.games?.map((g, index) => (
                                            <SwiperSlide className={classes.game_carousel_container_slide_2} key={index}
                                              onClick={()=>handleNavigate(g?.game_url)}
                                            >
                                                <div className={classes.game_carousel_container_2}>
                                                    <div className={classes.game_carousel_image_2}>
                                                        <img src={g?.game_banner} alt={g?.game_name} className={classes.game_carousel_img_2} />
                                                    </div>
                                                    <p className={classes.game_carousel_title_2}>
                                                        {g?.game_name}
                                                    </p>

                                                    <button type="button" className={classes.hero_play_button}>
                                                        Play Now
                                                    </button>
                                                </div>

                                            </SwiperSlide>
                                        ))}
                                </Swiper>
                            </div>
                        </>


                    )
                })}

            </section>

            <section className={classes.hero_section_2}>

                <div className={classes.hero_section_three}>
                    {games?.slice(2, 3)?.map((game, idx) => {
                        return (
                            <div className={classes.hero_section_three_container}>
                                <h3 className={classes.hero_section_three_heading}>Top {game?.category_name} Games</h3>

                                {game?.games.slice(0, 5)?.map((g, index) => (
                                    <div className={classes.hero_section_three_game_container} key={index}
                                      onClick={()=>handleNavigate(g?.game_url)}
                                    >
                                        <div className={classes.hero_section_three_game_image_container}>
                                            <img src={g?.game_banner} alt={g?.game_name} className={classes.hero_section_three_game_image} />
                                        </div>
                                        <div className={classes.hero_section_three_content_container}>
                                            <p className={classes.hero_section_three_game_name}>{g?.game_name}</p>
                                            <p className={classes.hero_section_three_game_desc}>{g?.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )
                    })}

                </div>

                <div className={classes.hero_section_two_2}>
                    <img src="/assets/images/gradient.png" alt="gradient" className={classes.hero_section_two_image_2} />
                    <img src="/assets/images/player.png" alt="player" className={classes.player_image_2} />
                </div>

                <div className={classes.hero_section_three}>
                    {games?.slice(3, 4)?.map((game, idx) => {
                        return (
                            <div className={classes.hero_section_three_container}>
                                <h3 className={classes.hero_section_three_heading}>Top {game?.category_name} Games</h3>

                                {game?.games.slice(0, 5)?.map((g, index) => (
                                    <div className={classes.hero_section_three_game_container} key={index}
                                      onClick={()=>handleNavigate(g?.game_url)}
                                    >
                                        <div className={classes.hero_section_three_game_image_container}>
                                            <img src={g?.game_banner} alt={g?.game_name} className={classes.hero_section_three_game_image} />
                                        </div>
                                        <div className={classes.hero_section_three_content_container}>
                                            <p className={classes.hero_section_three_game_name}>{g?.game_name}</p>
                                            <p className={classes.hero_section_three_game_desc}>{g?.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )
                    })}

                </div>

            </section>

            {games?.slice(3)?.map((game, idx) => {
                return (
                    <section className={classes.games_carousel} style={{ marginTop: "40px" }} key={idx}>
                        <div className={classes.games_carousel_header}>
                            <h1 className={classes.games_carousel_title}>{game?.category_name} Games</h1>

                            <button className={classes.game_carousel_header_button}>
                                <FaArrowRight className={classes.game_carousel_link_arrow} />
                            </button>
                        </div>

                        <div className={classes.games_carousel_sub_section}>
                            <Swiper
                                modules={[
                                    Autoplay,
                                    Navigation,
                                    Keyboard
                                ]}
                                slidesPerGroupSkip={1}
                                grabCursor={true}
                                keyboard={{
                                    enabled: true,
                                }}
                                loop
                                spaceBetween={8}
                                // slidesPerView={3}
                                slidesPerView={'auto'}
                                autoplay={{
                                    delay: 1000,
                                    disableOnInteraction: false,
                                }}
                                // navigation={{
                                //     prevEl: ".custom-swiper-prev",
                                //     nextEl: ".custom-swiper-next",
                                // }}
                                onSwiper={(swiper) => null}
                                onSlideChange={() => null}
                            >
                                {game?.games?.map((g, index) => (
                                    <SwiperSlide className={classes.game_carousel_container_slide_2} key={index}
                                      onClick={()=>handleNavigate(g?.game_url)}
                                    >
                                        <div className={classes.game_carousel_container_2}>
                                            <div className={classes.game_carousel_image_2}>
                                                <img src={g?.game_banner} alt={g?.game_name} className={classes.game_carousel_img_2} />
                                            </div>
                                            <p className={classes.game_carousel_title_2}>
                                                {g?.game_name}
                                            </p>

                                            <button type="button" className={classes.hero_play_button}>
                                                Play Now
                                            </button>
                                        </div>
                                    </SwiperSlide>
                                ))}

                            </Swiper>
                        </div>

                    </section>
                )
            })}

            <footer className={classes.footer_container}>
                <div className={classes.footer_sub_container}>

                    {/* Logo + Links */}
                    <div className={classes.footer_grid}>
                        <div className={classes.logo_container2}>
                            <img
                                src="/assets/images/logo.png"
                                alt="GamePlex logo"
                                className={classes.logo}
                            />
                            <p className={classes.logo_text}>
                                Game<span>Plex</span>
                            </p>
                        </div>

                        <p className={classes.footer_link}>Home</p>
                        <p className={classes.footer_link}>Games</p>
                        {/* <p className={classes.footer_link}>Terms & Conditions</p> */}
                    </div>

                    {/* Categories */}
                    <div className={classes.footer_grid}>
                        <p className={classes.footer_heading}>Categories</p>
                        <p className={classes.footer_link}>Action</p>
                        <p className={classes.footer_link}>Adventure</p>
                        <p className={classes.footer_link}>Casual</p>
                    </div>

                </div>

                {/* Bottom bar */}
                <div className={classes.footer_bottom}>
                    © Bharat Tech Solutions LLP 2025
                </div>
            </footer>

        </>
    )
}

export default HomePage;

// const categories = [
//     { title: "Action", image: "/assets/images/game1.png" },
//     { title: "Racing", image: "/assets/images/game2.png" },
//     { title: "Puzzle", image: "/assets/images/game3.png" },
//     { title: "Adventure", image: "/assets/images/game4.png" },
//     { title: "Sports", image: "/assets/images/game5.png" },
//     { title: "Arcade", image: "/assets/images/game6.png" },
//     { title: "Kids", image: "/assets/images/game7.png" },
//     { title: "Multiplayer", image: "/assets/images/game5.png" }
// ];